import React, { useState } from 'react';
import _ from 'lodash';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Card, CardContent, Hidden } from '@material-ui/core';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import DetailsListItem from 'modules2/components/DetailsListItem';
import { ShowMore } from 'modules2/components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import container from './FavouriteCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  nextBtn: {
    color: '#ffffff',
    width: 300,
    fontWeight: 400,
    fontFamily: 'Arial',
    textTransform: 'uppercase',
    paddingTop: 10,
    marginBottom: 10,
    backgroundColor: theme.palette.buttonBackground,
    '&:hover': {
      backgroundColor: theme.palette.nextBtnHover,
    },
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    paddingBottom: theme.spacing(1),
  },
}));

const FavouriteCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.up('xs'));

  const {
    userhistoryRadioState: { history, heartedStationIds },
    onViewRadioPlayerStart,
    onDeleteFavoriteRadioStation,
    onShowSnackbarNotification,
  } = props;

  const [moreValue, setMoreValue] = useState(matchesSM ? 6 : 6);
  const nextRadioList = () => setMoreValue(moreValue + 6);

  const onClickHandler = (id) => {
    onViewRadioPlayerStart(id);
  };

  const onDeleteClick = (value) => {
    onShowSnackbarNotification(`Favourite Radio deleted 😢`);
    onDeleteFavoriteRadioStation(value);
  };

  const displayFavouriteList = (loading, num) => {
    if (loading) {
      return [...Array(num)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    const items = heartedStationIds
      .map((id) => history[id])
      .filter((x) => !_.isEmpty(x) && !_.isNil(x));

    return (
      items.length === 0 ?
        (
          <div className={classes.empty}>
            Favorite not available.
          </div>
        ) :
        (
          items
            .reverse()
            .slice(0, moreValue)
            .map((radio, index) => {
              return (
                <DetailsListItem
                  hearted
                  editable
                  key={radio.stationuuid}
                  stationid={radio.stationuuid}
                  isPlayed={false}
                  isPinned={false}
                  image={radio.favicon}
                  title={radio.name}
                  subtitle={radio.tags}
                  url={radio.url_resolved}
                  radio_id={radio.stationuuid}
                  radio={radio}
                  onClick={onClickHandler}
                  onDeleteClick={onDeleteClick}
                />
              );
            })
          )
    );
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden smDown>
          <div className={classes.listContainer}>
            {displayFavouriteList(false, 3)}
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.listContainer}>
            {displayFavouriteList(false, 1)}
          </div>
        </Hidden>
        {heartedStationIds.length > moreValue && (
            <ShowMore nextRadioList={nextRadioList}/>
        )}
      </CardContent>
    </Card>
  );
};

export default container(FavouriteCard);
